import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useGetPlayerFavorites } from 'js/hooks/socket/hooks';
import { IGetPlayerFavoritesResponseData } from 'js/hooks/socket/hooks/useGetPlayerFavorites/types';

import * as actions from '../store/actions';

export const useGetFavoriteGames = () => {
    const dispatch = useDispatch();
    const getFavoriteGames = useGetPlayerFavorites();

    return useCallback(async (): Promise<IGetPlayerFavoritesResponseData> => {
        let { favoriteGames = [] } = await getFavoriteGames();

        favoriteGames = favoriteGames.reverse();

        dispatch(actions.setGamesFavorites(favoriteGames));

        return { favoriteGames };

    }, [getFavoriteGames, dispatch]);
};
